import HandyCollapse from "handy-collapse"

const isAccordion = document.getElementsByClassName("accordion")
if (isAccordion.length > 0) {
  const myAccordion = new HandyCollapse()
  myAccordion.close()
}
